import { successNotifyService, failureNotifyService } from "@/services/errors.service.js";
import { isArray } from "core-js/fn/array";
import { isInteger } from "core-js/fn/number";
import { isBoolean } from "lodash";

export function checkInputFieldService(localData, action) {
    let cfObj = {};

    //////////////////////////////////////
    /// Skills
    //////////////////////////////////////

    if (action === 'savePersonalityTraits') {
        cfObj.fieldName = 'personalityTraits';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personality';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    }else if(action === 'savePersonalityTraits'){
      cfObj.fieldName = 'personalityTraits';
      cfObj.fieldValueIsNull = false; // this field can be null
      cfObj.collectionName = 'personality';
      cfObj.vuexServiceName = 'editor';
      return cfObj;
    }
    else if (action === 'savePersonalityTraitsGala') { // For Gala
        cfObj.fieldName = 'personalityTraitsGala';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personality';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'saveBroadcastPersonality') {
        cfObj.fieldName = 'broadcastPersonality';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personality';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'saveBroadcastPersonalityGala') { // For Gala
        cfObj.fieldName = 'broadcastPersonalityGala';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personality';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'savePersonalityStatements') {
        cfObj.fieldName = 'personalityStatements';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personality';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else if (action === 'savePersonalityStatementsGala') {
        cfObj.fieldName = 'personalityStatementsGala';
        cfObj.fieldValueIsNull = false; // this field can be null
        cfObj.collectionName = 'personality';
        cfObj.vuexServiceName = 'editor';
        return cfObj;

    } else {
        cfObj.fieldName = null;
        cfObj.fieldValueIsNull = true;
        cfObj.collectionName = null;
        cfObj.vuexServiceName = null;
        return cfObj;
    }

}

export function saveInputFieldService(payload) {

    const isUserLoggedIn = payload.isUserLoggedIn;
    const action = payload.action;
    const currentThis = payload.currentThis;
    // const localData = payload.localData;
    // const userId = payload.userId;
    const localPersonalityData = payload.localPersonalityData;

    const cfObj = checkInputFieldService(localPersonalityData, action);

    // // console.log(cfObj, payload);

    if (!isUserLoggedIn || cfObj.fieldValueIsNull) {
        return;
    }

    currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

    // // console.log("executing...", localData);

    const fieldName = cfObj.fieldName;
    const vuexServiceName = cfObj.vuexServiceName;

    const dataObj = {};

    dataObj["_id"] = localPersonalityData._id;

    /*if(action === "saveProfession") {
        dataObj["_id"] = userId;
        dataObj[`${fieldName}`] = localData[`${fieldName}`].trim();
    } else {
        dataObj["_id"] = localPersonalityData._id;
        dataObj[`${fieldName}`] = localPersonalityData[`${fieldName}`];
    }*/

    dataObj['collectionName'] = cfObj.collectionName;

    if (localPersonalityData[`${fieldName}`]) { // If field value is not null

        if(isInteger(localPersonalityData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Number(localPersonalityData[`${fieldName}`].toString().trim());
        } if(isBoolean(localPersonalityData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Boolean(localPersonalityData[`${fieldName}`].toString().trim());
        } if(isArray(localPersonalityData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = localPersonalityData[`${fieldName}`];
        } else {
            dataObj[`${fieldName}`] = localPersonalityData[`${fieldName}`].trim();
        }

    } else dataObj[`${fieldName}`] = null; // If field value is null

    // // console.log(dataObj);

    currentThis.$store
        .dispatch(`${vuexServiceName}/${action}`, dataObj)
        .then((res) => {
            currentThis.$store.commit(
                "editor/TOGGLE_SAVE_IN_PROGRESS",
                false
            );
            //// console.log(res);
        })
        .catch((err) => {
            throw err;
        });
}
